import { render, staticRenderFns } from "./CompetitionAggregationsTable.vue?vue&type=template&id=293ff432&scoped=true&"
import script from "./CompetitionAggregationsTable.vue?vue&type=script&lang=js&"
export * from "./CompetitionAggregationsTable.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionAggregationsTable.vue?vue&type=style&index=0&id=293ff432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293ff432",
  null
  
)

export default component.exports